"use server";

import bcrypt from "bcryptjs";
import { z } from "zod";
import { prisma } from "@/lib/prisma";

const signUpSchema = z.object({
  firstName: z.string().min(2, "Le prénom est trop court."),
  lastName: z.string().min(2, "Le nom est trop court."),
  email: z.string().email("Adresse email invalide."),
  phone: z.string().min(6, "Le numéro de téléphone est invalide."),
  address1: z.string().min(4, "L’adresse est trop courte."),
  address2: z.string().optional(),
  postalCode: z.string().min(2, "Le code postal est invalide."),
  city: z.string().min(2, "La ville est invalide."),
  country: z.string().min(2, "Le pays est invalide."),
  password: z.string().min(6, "Le mot de passe doit contenir au moins 6 caractères."),
});

export type SignUpState = {
  error?: string;
  success?: boolean;
};

export async function signUpAction(
  _prevState: SignUpState,
  formData: FormData
): Promise<SignUpState> {
  const parsed = signUpSchema.safeParse({
    firstName: formData.get("firstName"),
    lastName: formData.get("lastName"),
    email: formData.get("email"),
    phone: formData.get("phone"),
    address1: formData.get("address1"),
    address2: formData.get("address2") || undefined,
    postalCode: formData.get("postalCode"),
    city: formData.get("city"),
    country: formData.get("country"),
    password: formData.get("password"),
  });

  if (!parsed.success) {
    return {
      error: parsed.error.issues[0]?.message || "Formulaire invalide.",
    };
  }

  const {
    firstName,
    lastName,
    email,
    phone,
    address1,
    address2,
    postalCode,
    city,
    country,
    password,
  } = parsed.data;

  const existingUser = await prisma.user.findUnique({
    where: { email },
  });

  if (existingUser) {
    return {
      error: "Un compte existe déjà avec cette adresse email.",
    };
  }

  const passwordHash = await bcrypt.hash(password, 10);

  await prisma.user.create({
    data: {
      firstName,
      lastName,
      email,
      passwordHash,
      phone,
      role: "CUSTOMER",
      addresses: {
        create: {
          label: "Adresse principale",
          firstName,
          lastName,
          address1,
          address2,
          postalCode,
          city,
          country,
          phone,
          isDefault: true,
        },
      },
    },
  });

  return {
    success: true,
  };
}